import { Empty } from "../../ui/empty";
import { useIntl } from "react-intl"
import React, { useCallback, useEffect, useRef, useState } from "react";

import ActivityBars from "./components/ActivityBars/ActivityBars";
import CreateActivityForm, { ActivityFormRef } from "./components/CreateActivityForm/CreateActivityForm";
import { ActivityStatus } from "../../../enum/activity.enum";
import { activityStore } from "../../../store/activity.store";
import PageCard from "../../PageCard/PageCard";
import style from "./style.module.css";
import { RecordsActions } from "./components/RecordsActions/RecordsActions";
import { RecordsHistory } from "./components/RecordsHistory/RecordsHistory";
import { getViewSwitchOptions } from "./components/ViewSwitch/ViewSwitch";
import ActivityPie from "./components/ActivityPie/ActivityPie";
import FullCalendarView from "./components/FullCalendarView/FullCalendarView";
import BlockyCalendarView from "./components/BlockyCalendarView/BlockyCalendarView";
import { Modal } from "../../ui/modal";

const RecordsPage = () => {
  const { formatMessage } = useIntl();
  const getIntervals = activityStore(state => state.getIntervalsStartPage);
  const getStatistics = activityStore(state => state.getStatistics);
  const setActivityToCreate = activityStore(state => state.setActivityToCreate);
  const daysIntervals = activityStore(state => state.daysIntervals || []);
  const activityToCreate = activityStore(state => state.activityToCreate);
  const getIntervalsLoading = activityStore(state => state.loading.getIntervalsStartPage);
  const getStatisticsLoading = activityStore(state => state.loading.getStatistics);
  const createActivityLoading = activityStore(state => state.loading.createActivity);
  const activitiesLength = activityStore(state => state.activities?.filter(activity => activity.status === ActivityStatus.RUNNING).length || 0);
  const { from, to, types, groupBy, tags} = activityStore(state => state.intervalsParams);

  const viewOptions = getViewSwitchOptions(formatMessage);

  const formRef = useRef<ActivityFormRef>(null);

  const [view, setView] = useState<string>(viewOptions[0].key);

  const onOkHandler = useCallback(() => {
    formRef.current?.submit();
  }, []);

  const cancelHandler = useCallback(() => setActivityToCreate(null), [setActivityToCreate]);

  const isDataExist = !!daysIntervals?.length;

  useEffect(() => {
    !getIntervalsLoading && getIntervals();
    !getStatisticsLoading && getStatistics();
  }, [from, to, types, activitiesLength, groupBy, tags]);

  return <>
    <RecordsActions view={view} setView={setView} />

    {view === viewOptions[1].key && (
      <FullCalendarView />
    )}
    {view === viewOptions[2].key && (
      <BlockyCalendarView />
    )}
    {view === viewOptions[3].key && (
      <PageCard title={null}>
        <div className={style.ChartsContainer}>
          {isDataExist ? <ActivityBars/> : <Empty/>}
        </div>
      </PageCard>
    )}
    {view === viewOptions[4].key && (
      <PageCard title={null}>
        <div className={style.ChartsContainer}>
          {isDataExist ? <ActivityPie /> : <Empty/>}
        </div>
      </PageCard>
    )}
    {view === viewOptions[0].key && <RecordsHistory />}

    <Modal
      title={formatMessage({ id: 'CREATE_ACTIVITY' })}
      open={!!activityToCreate}
      onOk={onOkHandler}
      onCancel={cancelHandler}
      okText={formatMessage({ id: 'SAVE' })}
      confirmLoading={createActivityLoading}
    >
      {!!activityToCreate && <CreateActivityForm ref={formRef} activity={activityToCreate} />}
    </Modal>
  </>
}

export default RecordsPage;
